<template>
  <div class="mv-bg-main">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div slot="header" class="clearfix">
            <span>查询条件</span>
          </div>
          <el-form
            :inline="true"
            :model="formInline"
            ref="searchForm"
            label-width="100px"
            class="demo-form-inline"
          >
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="formInline.sysId"
                placeholder="请选择业务系统"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参数名称" prop="paramsName">
              <el-input v-model="formInline.paramsName" placeholder="请输入参数名称"></el-input>
            </el-form-item>
            <el-form-item class="float-r">
              <el-button size="small" @click="onReset('searchForm')">重置</el-button>
              <el-button type="primary" size="small" @click="onSearch()">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <el-card >
      <div slot="header" class="clearfix">
        <span class="card-title">接口参数维护</span>
        <el-button size="small" type="primary" style="float: right; margin-top: -10px; margin-right: 10px;" @click="handleAdd" icon="el-icon-plus"></el-button>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%">
        <!-- <el-table-column
          label="序号"
          type="index"
          >
        </el-table-column> -->
        <el-table-column
          label="业务系统"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.sysName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="接口参数编号"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.interfaceParamId }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="参数类型"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.paramTypeId === '1' ? 'String': 'Integer'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="出入参标志"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.paramType === '1' ? '入参': '出参' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="参数名称"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.paramName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="参数标志"
          :show-overflow-tooltip="tooltip"
          width="">
          <template slot-scope="scope">
            <span >{{ scope.row.paramIdentify }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt center"
        background
        @size-change="handleSizeChange"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page"
        layout="total, sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-card>
    <el-dialog @close="closeInterface" :title="interfaceTitle"  width="450px" center :modal-append-to-body='false' :visible.sync="interfaceDialog">
      <el-form :model="interfaceInfo" :rules="interfaceRule" ref="interfaceInfo" >
        <el-form-item label="业务系统:" prop="sysId" :required="required"  :label-width="formLabelWidth">
          <el-select  v-model="interfaceInfo.sysId" clearable filterable  placeholder="请选择业务系统">
            <el-option :label="item.systemName" :value="item.systemId" v-for="(item, $index) in sysData" :key="$index" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数名称:" prop="paramName"  :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" placeholder="请输入参数名称" maxlength="30" clearable v-model="interfaceInfo.paramName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="参数英文标识:"  prop="paramIdentify" :required="required" :label-width="formLabelWidth">
          <el-input style="width: 217px;" :disabled="!add" placeholder="请输入参数英文标识" maxlength="30" clearable v-model="interfaceInfo.paramIdentify" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="参数类型:" prop="paramTypeId" :required="required"  :label-width="formLabelWidth">
          <el-select  v-model="interfaceInfo.paramTypeId" clearable filterable  placeholder="请选择参数类型">
            <el-option label="String" value="1" ></el-option>
            <el-option label="Integer" value="2" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="出入参标记:" prop="paramType" :required="required"  :label-width="formLabelWidth">
          <el-select  v-model="interfaceInfo.paramType" clearable filterable  placeholder="请选择出入参标记">
            <el-option label="出参" value="0" ></el-option>
            <el-option label="入参" value="1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述:" :label-width="formLabelWidth">
          <el-input type="textarea" style="width: 217px;" maxlength="150" placeholder="请输入描述" v-model="interfaceInfo.desc"></el-input>
        </el-form-item>
        <el-form-item style="textAlign: center;">
          <el-button @click="interfaceDialog=false">取 消</el-button>
          <el-button type="primary" v-show="add" @click="addSave('interfaceInfo')">确 定</el-button>
          <el-button type="primary" v-show="!add" @click="editSave('interfaceInfo')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
@import "../../assets/sass/base.scss";
</style>
<script>
export default {
  name: 'interfaceParams',
  data () {
    return {
      required: true,
      tooltip: true,
      interfaceDialog: false,
      modalClick: false,
      formLabelWidth: '120px',
      add: false,
      formInline: {
        sysId: '',
        paramsName: ''
      },
      interfaceTitle: '',
      tableData: [],
      interfaceParamId: '',
      interfaceInfo: {
        paramTypeId: '',
        sysId: '',
        paramIdentify: '',
        paramName: '',
        paramType: '',
        desc: ''
      },
      interfaceRule: {
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        paramTypeId: [
          { required: true, message: '请选择参数类型', trigger: 'change' }
        ],
        paramType: [
          { required: true, message: '请选择出入参标记', trigger: 'change' }
        ],
        paramName: [
          { required: true, message: '请输入参数名称', trigger: ['blur', 'change'] },
          { min: 1, max: 30, message: '长度在1至30个字符', trigger: ['blur', 'change'] }
        ],
        paramIdentify: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              if ((/[^\w_]/g).test(value)) {
                callback(new Error('请填写英文和数字'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请填写英文和数字'))
            }
          },
          trigger: ['blur', 'change'],
          required: true
        }]
      },
      currentPage: 1,
      page: 10,
      total: 0
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    onSubmit () {
      this.currentPage = 1
      this.page = 10
      this.query()
    },
    handleSizeChange (val) {
      this.page = val
      this.currentPage = 1
      this.query()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.query()
    },
    onSearch () {
      this.currentPage = 1
      this.query()
    },
    onReset () {
      this.formInline.sysId = ''
      this.formInline.paramsName = ''
    },
    handleEdit (index, row) { // 编辑
      this.interfaceParamId = row.interfaceParamId
      this.interfaceInfo.sysId = Number(row.sysId)
      this.interfaceInfo.paramName = row.paramName
      this.interfaceInfo.paramIdentify = row.paramIdentify
      this.interfaceInfo.paramTypeId = row.paramTypeId
      this.interfaceInfo.paramType = row.paramType
      this.interfaceInfo.desc = row.paramDesc
      this.add = false
      this.interfaceTitle = '编辑接口参数维护'
      this.interfaceDialog = true
    },
    closeInterface () {
      this.interfaceInfo = {
        paramTypeId: '',
        sysId: '',
        paramIdentify: '',
        paramName: '',
        paramType: '',
        desc: ''
      }
      this.$refs['interfaceInfo'].resetFields() // 关闭时清除验证条件
      this.interfaceDialog = false
    },
    editSave (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          if (_this.interfaceInfo.sysId) {
            sysIds.push(_this.interfaceInfo.sysId)
          }
          op.sysIds = sysIds
          op.paramTypeId = _this.interfaceInfo.paramTypeId
          op.paramType = _this.interfaceInfo.paramType
          op.paramName = _this.interfaceInfo.paramName
          op.interfaceParamId = _this.interfaceParamId
          op.paramDesc = _this.interfaceInfo.desc
          _this.$axios({
            url: _this.$API.config.updateInterfaceParamInfo,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('编辑成功!')
            _this.interfaceDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    handleAdd () {
      this.add = true
      this.interfaceTitle = '新增接口参数维护'
      this.interfaceDialog = true
    },
    addSave (formName) { // 新增
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let op = {}
          let sysIds = []
          if (_this.interfaceInfo.sysId) {
            sysIds.push(_this.interfaceInfo.sysId)
          }
          op.sysIds = sysIds
          op.paramTypeId = _this.interfaceInfo.paramTypeId
          op.paramType = _this.interfaceInfo.paramType
          op.paramName = _this.interfaceInfo.paramName
          op.paramIdentify = _this.interfaceInfo.paramIdentify
          op.paramDesc = _this.interfaceInfo.desc
          _this.$axios({
            url: _this.$API.config.addInterfaceParamInfo,
            method: 'post',
            data: op
          }).then((response) => {
            _this.query()
            _this.$message.success('新增成功!')
            _this.interfaceDialog = false
          }).catch((err) => {
            console.log(err)
          })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    initData () {
      if (!this.sysData.length) {
        this.$store.dispatch('getSystem')
      }
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.currentPage
      op.pageSize = this.page
      op.paramName = this.formInline.paramsName
      op.sysIds = sysIds
      this.$axios({
        url: _this.$API.config.queryInterfaceParamInfoListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableData = response.data.resData.rows
        _this.total = response.data.resData.total
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.initData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/config/interfaceParams.vue